import { API } from "aws-amplify";
import { listUnits } from "~/graphql/queries";
import { GRAPHQLFilters, LoaderData } from "~/types";
import { getGraphqlFilters } from "~/utils";
import * as APITypes from "~/API";

export const getUnitList = async ({
  ownerID,
  ownerType,
  buildingID,
  includeDeleted = "exclude",
}: {
  ownerID?: string;
  ownerType?: APITypes.OwnerType;
  buildingID?: string;
  includeDeleted?: "all" | "exclude" | "only";
}): Promise<LoaderData<APITypes.Unit[]>> => {
  let filters: GRAPHQLFilters = getGraphqlFilters({
    ownerID,
    ownerType,
    buildingID,
  });

  // Add _deleted filter based on includeDeleted parameter
  if (includeDeleted === "exclude") {
    filters._deleted = { ne: true };
  } else if (includeDeleted === "only") {
    filters._deleted = { eq: true };
  }
  // If includeDeleted === "all", don't add any _deleted filter
  let items: APITypes.Unit[] = [];
  let nextToken: string | null | undefined = undefined;
  try {
    do {
      let response = (await API.graphql({
        query: listUnits,
        variables: {
          filter: filters,
          nextToken,
        },
      })) as { data?: APITypes.ListUnitsQuery };

      const allUnits =
        response.data?.listUnits?.items?.filter(
          (item): item is APITypes.Unit => item !== null
        ) ?? [];
      items.push(...allUnits);
      nextToken = response.data?.listUnits?.nextToken;
    } while (nextToken);

    return {
      success: true,
      data: items,
    };
  } catch (error) {
    console.error("Error getting unit list", error);
    return {
      success: false,
      data: [],
      error,
    };
  }
};
